import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const groupProgressTestsManagement = createApi({
    reducerPath: "groupProgressTestsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        groupProgressTestsList: builder.mutation({
            query: () => ({
                url: `v1/${locale}/settings/group-progress-test`,
                method: "GET",
                
            }),
        }),
        viewGroupProgressTest: builder.mutation({
            query: (testId) => ({
                url: `v1/${locale}/settings/group-progress-test/${testId}`,
                method: "GET",
            }),
        }),

        addGroupProgressTest: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/group-progress-test`,
                method: "POST",
                body: body,
            }),
        }),

        deleteGroupProgressTest: builder.mutation({
            query: (testId) => ({
                url: `v1/${locale}/settings/group-progress-test/${testId}`,
                method: "DELETE",
            }),
        }),

        
    }),
});

export const { 
    useGroupProgressTestsListMutation,
    useViewGroupProgressTestMutation,
    useAddGroupProgressTestMutation,
    useDeleteGroupProgressTestMutation
} = groupProgressTestsManagement;
